
import { useState, useEffect } from 'react';
import { getShops } from '@/lib/supabase/shops';

export const useProductShopData = (shopSlug: string | undefined) => {
  const [shopId, setShopId] = useState<string | null>(null);
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShopId = async () => {
      if (!shopSlug) {
        console.log("Aucun slug de boutique fourni");
        setLoading(false);
        return;
      }
      
      try {
        console.log("Recherche de la boutique avec le slug:", shopSlug);
        const shops = await getShops();
        
        if (!shops || shops.length === 0) {
          console.log("Aucune boutique trouvée");
          setLoading(false);
          return;
        }
        
        // Normalize shop slug for comparison
        const normalizedShopSlug = shopSlug.toLowerCase().trim();
        
        // First try to find by exact slug match
        let shop = shops.find(shop => {
          const shopDbSlug = shop.slug?.toLowerCase().trim();
          console.log(`Comparaison slug: "${shopDbSlug}" avec "${normalizedShopSlug}"`);
          return shopDbSlug === normalizedShopSlug;
        });
        
        // If no slug match found, try the old way with normalized name
        if (!shop) {
          console.log("Aucun slug correspondant, tentative avec le nom normalisé");
          const normalizedShopName = shopSlug.toLowerCase().replace(/-/g, ' ').trim();
          
          shop = shops.find(shop => {
            const normalizedName = shop.name.toLowerCase().replace(/\s+/g, ' ').trim();
            console.log(`Comparaison nom: "${normalizedName}" avec "${normalizedShopName}"`);
            return normalizedName === normalizedShopName;
          });
        }
        
        if (shop) {
          console.log("Boutique trouvée:", shop.name, "avec ID:", shop.id);
          setShopId(shop.id);
          
          // If the shop has an organization_id, use it
          if (shop.organization_id) {
            console.log("Organisation récupérée depuis la boutique:", shop.organization_id);
            setOrganizationId(shop.organization_id);
          }
        } else {
          console.error("Aucune boutique trouvée avec le slug ou le nom:", shopSlug);
          console.log("Boutiques disponibles:", shops.map(s => `"${s.name}" (slug: "${s.slug}")`).join(', '));
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des boutiques:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchShopId();
  }, [shopSlug]);

  return { shopId, organizationId, loading };
};
